const x = {
  tm: {
    fullScreenControl: true,
    locatorControl: true,
    gazetteerSearchBox: true,
    noInitialLoadingText: true,
    gazetteerSearchBoxPlaceholdertext: "Stadtteil | Adresse | POI",
    photoLightBox: true,
    fallbackBackgroundlayers: "wupp-plan-live@90",
    previewFeatureCollectionCount: -1,
    previewMapPosition: "lat=51.30849778367392&lng=7.2529529926447776&zoom=11",
    gazetteerTopicsList: ["pois", "kitas", "quartiere", "bezirke", "adressen"],
    home: {
      center: [51.30809014045725, 7.252747363995086],
      zoom: 14,
    },
    applicationMenuTooltipString: "Einstellungen | Anleitung",
    applicationMenuTitle: "Einstellungen und Kompaktanleitung",
    applicationMenuIntroductionMarkdown:
      "Über **Einstellungen** können Sie die Darstellung der Hintergrundkarte und der Wasserstofftankstelle an Ihre Vorlieben anpassen. Wählen Sie **Kompaktanleitung**  für detailliertere Bedienungsinformationen.",
    applicationMenuIconname: "bars",
    clusterOptions: {
      spiderfyOnMaxZoom: false,
      showCoverageOnHover: false,
      zoomToBoundsOnClick: false,
      maxClusterRadius: 40,
      disableClusteringAtZoom: 19,
      animate: false,
      cismapZoomTillSpiderfy: 12,
      selectionSpiderfyMinZoom: 12,
    },
    minZoom: 5,
    maxZoom: 19,
  },
  city: "Wuppertal",
};
export default x;
